import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { CreditCard } from 'lucide-react';

export const InhaberSubscriptionTab = ({ subscription, onOpenCheckout }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <Card className="bg-gray-900/50 border-gray-800">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-yellow-500" />
            Ihr Abonnement
          </CardTitle>
        </CardHeader>
        <CardContent>
          {subscription ? (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-black/30 p-4 rounded-lg">
                  <p className="text-gray-500 text-sm">Status</p>
                  <p className={`text-xl font-bold ${
                    subscription.status === 'active' ? 'text-green-500' :
                    subscription.status === 'trial' ? 'text-yellow-500' : 'text-gray-400'
                  }`}>
                    {subscription.status === 'trial' ? 'Testversion' :
                     subscription.status === 'active' ? 'Aktiv' : subscription.status}
                  </p>
                </div>
                <div className="bg-black/30 p-4 rounded-lg">
                  <p className="text-gray-500 text-sm">Mitarbeiter</p>
                  <p className="text-xl font-bold text-white">{subscription.employee_count || 0}</p>
                </div>
                <div className="bg-black/30 p-4 rounded-lg">
                  <p className="text-gray-500 text-sm">Abrechnungszyklus</p>
                  <p className="text-xl font-bold text-white">
                    {subscription.billing_cycle === 'yearly' ? 'Jährlich' : 'Monatlich'}
                  </p>
                </div>
                <div className="bg-black/30 p-4 rounded-lg">
                  <p className="text-gray-500 text-sm">Monatlicher Preis</p>
                  <p className="text-xl font-bold text-yellow-500">
                    {subscription.pricing?.monthly_total?.toFixed(2) || subscription.pricing?.monthly_equivalent?.toFixed(2)}€
                  </p>
                </div>
              </div>

              {subscription.status === 'trial' && (
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4">
                  <p className="text-yellow-400 font-medium">Testversion aktiv</p>
                  <p className="text-gray-400 text-sm mt-1">
                    Ihre Testversion endet am {new Date(subscription.trial_ends_at).toLocaleDateString('de-DE')}.
                    Aktivieren Sie Ihr Abo, um alle Funktionen weiter zu nutzen.
                  </p>
                  <Button
                    className="mt-4 bg-yellow-500 text-black hover:bg-yellow-400"
                    onClick={() => onOpenCheckout('basis')}
                    data-testid="activate-subscription-btn"
                  >
                    Jetzt Abo aktivieren
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-8">
              <CreditCard className="w-12 h-12 text-gray-600 mx-auto mb-4" />
              <p className="text-gray-400">Kein aktives Abonnement</p>
              <Button
                className="mt-4 bg-yellow-500 text-black"
                onClick={() => navigate('/register')}
              >
                Abo starten
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
